import { useEffect, useState, useContext } from 'react';
import { Chart as ChartJS, registerables } from 'chart.js';
import { Bar } from 'react-chartjs-2'
import helpers from 'src/utils/helpers';
ChartJS.register(...registerables);

export const VerificationChart: React.FC<any> = ({chartData}) => {
    const [verifiedData, setVerifiedData] = useState<Array<number>>([])
    const [unverifiedData, setUnverifiedData] = useState<Array<number>>([])
    const [isSmallScreen, setIsSmallScreen] = useState(false);

    useEffect(() => {
        if (chartData) {
            const data = helpers.normalizeVerificationChartData(chartData)
            setVerifiedData(data.verifiedData)
            setUnverifiedData(data.unverifiedData)
        }
    }, [chartData])

    useEffect(() => {
        const handleResize = () => {
            setIsSmallScreen(window.innerWidth <= 500);
        };

        handleResize();

        window.addEventListener('resize', handleResize);

        return () => {
        window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <Bar 
            data={{
                labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'],
                datasets: [
                    {
                        label: 'Verified',
                        data: verifiedData, //[23, 35, 50, 38, 35, 37, 70, 62, 45, 52, 24, 33],
                        backgroundColor: '#27AE60',
                        barThickness: isSmallScreen ? 10 : 15,
                        borderColor: "rgba(0,0,0,0)",
                        borderWidth: 3,
                        borderRadius: 5,
                        
                    },
                    {
                        label: 'Unverified',
                        data: unverifiedData, // [30, 30, 50, 58, 42, 55, 34, 65, 55, 28, 64, 39],
                        backgroundColor: '#F2C94C',
                        barThickness: isSmallScreen ? 10 : 15,
                        borderColor: "rgba(0,0,0,0)",
                        borderWidth: 3,
                        borderRadius: 5
                    }
                ]
            }}
            height="90%"
            width="100%"
            options={{
                maintainAspectRatio: false, 
                plugins: {
                    legend: {
                        align: 'end',
                        labels: {
                            boxWidth: 8,
                            boxHeight: 8,
                            usePointStyle: true,
                            color: '#4F4F4F',
                            font: {
                                size: 12
                            }
                        }
                    }
                },
                scales: {
                    y: {  
                        //display: false,
                        grid: {
                            //display: false,
                            drawBorder: false,
                            lineWidth: 0.3,
                        },
                        ticks: {
                            color: "#4F4F4F",
                            font: {
                                size: 10
                            }
                        }
                    },
                    x: {  
                        grid: {
                            //display: false,
                            drawBorder: false,
                            lineWidth: 0.3,
                        },
                        ticks: {
                            color: "#4F4F4F", 
                            font: {
                                size: 10
                            }
                        }
                    }
                }
            }}
        />
    )
}
